import Editor from '@digit-fe/digit-editor-new';
import cx from 'classnames';
import React, { useMemo } from 'react';
import styles from './index.less';
import { IEditorProps } from '@digit-fe/digit-editor-new/dist/Editor/types/editor';
import { onFileAndVideoUpload } from '@/pages/camp/components/editor/uploadUtil';

/**
 * 打卡营后台设置富文本编辑器
 * @constructor
 */
const CampSettingsEditor = (props: IEditorProps) => {
  const content = props?.content;
  console.log('content是', props);
  const parseContent = useMemo(() => {
    if (typeof content === 'string') {
      try {
        return JSON.parse(content);
      } catch (e) {
        return '';
      }
    }
    if (typeof content === 'object') {
      return content;
    }
    return '';
  }, [content]);
  return (
    <Editor
      placeholder={'请输入'}
      className={cx(styles.Editor)}
      titleProps={{ showTitle: false }}
      editable={true}
      videoProps={{
        onVideoUpload: onFileAndVideoUpload,
      }}
      mode={'simple'}
      imageProps={{
        onImageUpload: onFileAndVideoUpload,
      }}
      attachProps={{
        onAttachUpload: onFileAndVideoUpload,
      }}
      {...props}
      content={parseContent}
    />
  );
};

export default CampSettingsEditor;
